<template>
  <div class="reporting-wrap">
    <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: "Reporting",
};
</script>
